import { Injectable } from '@angular/core';
import { QueryEntity } from '@datorama/akita';
import { compareEntities, compareEntity } from '@lycoris-nubila/ngx-lycoris';
import { isNil, reject, uniqBy } from 'lodash-es';
import { Observable } from 'rxjs';
import { distinctUntilChanged, map, shareReplay } from 'rxjs/operators';

import { Organization } from 'organization/organization';
import { OrganizationRepositoryPort } from 'organization/port/organization-repository.port';

import { CacheObservable } from '../../app-decorators';
import { OrganizationState, OrganizationStore } from './organization.store';

@Injectable()
export class OrganizationRepositoryAdapter
	extends QueryEntity<OrganizationState>
	implements OrganizationRepositoryPort
{
	constructor(protected store: OrganizationStore) {
		super(store);
	}

	@CacheObservable()
	public observeOrganizationById(id: string): Observable<Organization> {
		return this.selectEntity(id).pipe(
			map((document) => this.store.asEntity(document)),
			distinctUntilChanged(compareEntity),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	@CacheObservable()
	public observeOrganizationByIds(ids: string[]): Observable<Organization[]> {
		return this.selectMany(ids).pipe(
			map((documents) =>
				documents.map((document) => this.store.asEntity(document))
			),
			distinctUntilChanged(compareEntities),
			shareReplay({ bufferSize: 1, refCount: true })
		);
	}

	public async saveOrganizations(entities: Organization[]): Promise<void> {
		this.store.upsertMany(
			uniqBy(
				reject(entities, isNil).map((e) => this.store.asDocument(e)),
				'id'
			)
		);
	}
}
